export enum PersonalAreaTabs {
  PERSONAL_AREA = 'personalArea',
  MY_TENBIS = 'myTenbis',
  MY_ORDERS = 'myOrders',
  PAYMENTS = 'payments',
  MY_BENEFITS = 'myBenefits',
  SETTINGS = 'settings',
}
